<div class="splash">
  <img src="/assets/png/logo.png" alt="logo"> Reptimer
</div>
